export const PRIORITY_COLORS = {
	low: 'default',
	medium: 'info',
	high: 'warning',
	critical: 'error',
}

export const STATUS_COLORS = {
	open: 'error',
	in_progress: 'warning',
	resolved: 'success',
	closed: 'default',
}

export const STATUS_OPTIONS = ['open', 'in_progress', 'resolved', 'closed']

export const PRIORITY_OPTIONS = ['low', 'medium', 'high', 'critical']
